import { useEffect, useState } from 'react';

declare global {
  interface Window {
    __forceMobile?: boolean;
    __setForceMobile?: (flag: boolean) => void;
  }
}

const MOBILE_QUERY = '(max-width: 640px)';

const read = () =>
  window.__forceMobile === true ||
  (typeof window.matchMedia === 'function' && window.matchMedia(MOBILE_QUERY).matches);

/** True under 640px. `window.__setForceMobile(true)` forces mobile
 *  rendering regardless of viewport (used for demos and testing). */
export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(read);

  useEffect(() => {
    const mq = typeof window.matchMedia === 'function' ? window.matchMedia(MOBILE_QUERY) : null;
    const onChange = () => setMobile(read());
    mq?.addEventListener('change', onChange);
    window.addEventListener('etc:forcemobile', onChange);
    return () => {
      mq?.removeEventListener('change', onChange);
      window.removeEventListener('etc:forcemobile', onChange);
    };
  }, []);

  return mobile;
}

if (typeof window !== 'undefined') {
  window.__setForceMobile = (flag: boolean) => {
    window.__forceMobile = !!flag;
    window.dispatchEvent(new Event('etc:forcemobile'));
  };
}
